import clsx from "clsx";
import React from "react";
import styles from "@/styles/formulary.module.scss";
import FormularyForm from "@/components/formulary/formularyForm";

const FormularyPage = () => {
  return (
    <div className={clsx("container", styles.main)}>
      <div className={styles.header}>
        <h1>Formulary Search</h1>
        <p className="">
          A formulary is a list of medications included in your health plan
          coverage. Your doctor and other healthcare providers use this list to
          ensure they prescribe the safest and most effective medications for
          you.
          <br />
          <br />
          Check which medications are covered in your area
        </p>
      </div>

      <div className={styles.formContainer}>
        <FormularyForm />
      </div>
    </div>
  );
};

export default FormularyPage;
